var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import moment from 'moment';
import React, { useContext, useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import styled from 'styled-components';
import WindowEventContext from '../../context/window-event-context';
import { getGeometryStyle } from '../../helpers/styles';
import { StyledComboBox } from '../ComboBox';
import { StyledTextInput } from '../TextInput';
var StyledCalendarContainer = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  background-color: ", ";\n  color: ", ";\n  text-align: center;\n  .day-tile: {\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  ", "\n  background-color: ",
    ";\n  color: ", ";\n  text-align: center;\n  .day-tile: {\n    background-color: ",
    ";\n    color: ", ";\n  }\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme === null || windowTheme === void 0 ? void 0 : windowTheme.calendarContainer) === null || _b === void 0 ? void 0 : _b.backgroundCalendar;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme === null || windowTheme === void 0 ? void 0 : windowTheme.calendarContainer) === null || _b === void 0 ? void 0 : _b.color;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme === null || windowTheme === void 0 ? void 0 : windowTheme.calendarContainer) === null || _b === void 0 ? void 0 : _b.backgroundCalendar;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme === null || windowTheme === void 0 ? void 0 : windowTheme.calendarContainer) === null || _b === void 0 ? void 0 : _b.color;
});
var StyledCalendarHeader = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 20% 35% 25% 20%;\n  grid-column-gap: 10px;\n  width: 90%;\n"], ["\n  display: grid;\n  grid-template-columns: 20% 35% 25% 20%;\n  grid-column-gap: 10px;\n  width: 90%;\n"])));
var StyledCalendar = styled(Calendar)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  .day-tile: {\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  .day-tile: {\n    background-color: ",
    ";\n    color: ", ";\n  }\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme === null || windowTheme === void 0 ? void 0 : windowTheme.calendarContainer) === null || _b === void 0 ? void 0 : _b.backgroundCalendar;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme === null || windowTheme === void 0 ? void 0 : windowTheme.calendarContainer) === null || _b === void 0 ? void 0 : _b.color;
});
var StyledImageContainer = styled.div.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  border: ", ";\n  border-left-color: ", ";\n  border-top-color: ", ";\n  border-right-color: ", ";\n  border-bottom-color: ", ";\n"], ["\n  border: ", ";\n  border-left-color: ",
    ";\n  border-top-color: ",
    ";\n  border-right-color: ",
    ";\n  border-bottom-color: ",
    ";\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme === null || windowTheme === void 0 ? void 0 : windowTheme.calendarContainer) === null || _b === void 0 ? void 0 : _b.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme === null || windowTheme === void 0 ? void 0 : windowTheme.calendarContainer) === null || _b === void 0 ? void 0 : _b.borderColor.left;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme === null || windowTheme === void 0 ? void 0 : windowTheme.calendarContainer) === null || _b === void 0 ? void 0 : _b.borderColor.top;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme === null || windowTheme === void 0 ? void 0 : windowTheme.calendarContainer) === null || _b === void 0 ? void 0 : _b.borderColor.right;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    var _b;
    return (_b = windowTheme === null || windowTheme === void 0 ? void 0 : windowTheme.calendarContainer) === null || _b === void 0 ? void 0 : _b.borderColor.bottom;
});
var CalendarWidget = function (props) {
    var attributes = props.attributes, windowTheme = props.windowTheme;
    var _onDaySelect = useContext(WindowEventContext)._onDaySelect;
    var geometry = (attributes || {}).geometry;
    var months = [
        { label: 'January', value: 0 },
        { label: 'February', value: 1 },
        { label: 'March', value: 2 },
        { label: 'April', value: 3 },
        { label: 'May', value: 4 },
        { label: 'June', value: 5 },
        { label: 'July', value: 6 },
        { label: 'August', value: 7 },
        { label: 'September', value: 8 },
        { label: 'October', value: 9 },
        { label: 'November', value: 10 },
        { label: 'December', value: 11 },
    ];
    var date = new Date();
    var _a = useState(date), activeStartDate = _a[0], setActiveStartDate = _a[1];
    var _b = useState(date), value = _b[0], onChange = _b[1];
    var _c = useState(date.getFullYear()), year = _c[0], setYear = _c[1];
    var _d = useState(date.getMonth()), month = _d[0], setMonth = _d[1];
    var onDayClick = function (date) {
        onChange(date);
        _onDaySelect(date);
    };
    var onMonthChange = function (eve) {
        setMonth(eve.target.value);
    };
    var setData = function (month, year) {
        var activeDate = new Date(year, month);
        setActiveStartDate(activeDate);
        setMonth(month);
        setYear(year);
    };
    var onPrevClick = function () {
        var prevMonth = month === 0 ? 11 : month - 1;
        var prevYear = month === 0 ? year - 1 : year;
        setData(prevMonth, prevYear);
    };
    var onNextClick = function () {
        var nextMonth = month === 11 ? 0 : month + 1;
        var nextYear = month === 11 ? year + 1 : year;
        setData(nextMonth, nextYear);
    };
    useEffect(function () {
        var activeDate = new Date(year, month);
        setActiveStartDate(activeDate);
    }, [month, year]);
    return (React.createElement(StyledCalendarContainer, { geometry: geometry, windowTheme: windowTheme },
        React.createElement(StyledCalendarHeader, null,
            React.createElement("div", null,
                React.createElement(StyledImageContainer, { windowTheme: windowTheme, onClick: onPrevClick }, "<")),
            React.createElement("div", null,
                React.createElement(StyledComboBox, { geometry: {}, windowTheme: windowTheme, value: month, onChange: onMonthChange }, months.map(function (month, index) { return (React.createElement("option", { value: month.value, key: "month" + index }, month.label)); }))),
            React.createElement("div", null,
                React.createElement(StyledTextInput, { windowTheme: windowTheme, value: year, onChange: function (evt) { return setYear(evt.target.value); }, type: "number", step: 1 })),
            React.createElement("div", null,
                React.createElement(StyledImageContainer, { onClick: onNextClick, windowTheme: windowTheme }, ">"))),
        React.createElement(StyledCalendar, { tileClassName: 'day-tile', activeStartDate: activeStartDate, onChange: onDayClick, value: value, formatShortWeekday: function (locale, date) { return moment(date).format('dd')[0]; }, showNavigation: false })));
};
export default CalendarWidget;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map